module.exports = __webpack_public_path__ + "img/GAME_SEAWORLD1.e00ba421.jpg";